import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { StaggerItem } from "@/components/Reveal";

export default function ServiceCard({ service, index }) {
  const Icon = service.icon;
  return (
    <StaggerItem>
      <Link
        to={`/services/${service.slug}`}
        data-testid={`service-card-${service.slug}`}
        className="group relative flex h-full flex-col justify-between overflow-hidden border border-fs-border bg-fs-card p-8 transition-[transform,border-color] duration-300 hover:-translate-y-1.5 hover:border-fs-gold/40"
      >
        <div>
          <div className="flex items-start justify-between">
            <span className="flex h-12 w-12 items-center justify-center border border-fs-border text-fs-gold transition-colors duration-300 group-hover:border-fs-gold/50">
              <Icon className="h-5 w-5" strokeWidth={1.4} />
            </span>
            <span className="font-serif text-sm text-fs-muted/50">
              0{index + 1}
            </span>
          </div>
          <h3 className="mt-7 font-serif text-2xl font-normal tracking-tight text-fs-ink">
            {service.title}
          </h3>
          <p className="mt-3 text-sm leading-relaxed text-fs-muted">
            {service.short}
          </p>
        </div>
        <div className="mt-8 flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-fs-muted transition-colors duration-300 group-hover:text-fs-gold">
          Explore
          <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </div>
        {/* hover glow line */}
        <span className="absolute inset-x-0 bottom-0 h-px w-0 bg-fs-gold/60 transition-all duration-500 group-hover:w-full" />
      </Link>
    </StaggerItem>
  );
}
